import styled from "styled-components";
import { palette } from "styled-theme";

const CalenderWrapper = styled.div`
  height: calc(100vh - 130px);
  .rbc-event {
    background-color: ${palette("primary", 0)};
  }
  .rbc-event-label {
    display: none;
  }
  .rbc-allday-cell {
    display: none;
  }
`;

export default CalenderWrapper;
